import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Mail, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-dark-800 border-t border-gold-900/30 pt-16 pb-8" data-id="element-37" data-mp="3ghc323c0v5or">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38" data-mp="32pff8bhdzhy6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-39" data-mp="36oy0x9h17x22">
          {/* Brand Column */}
          <div className="col-span-1 md:col-span-1" data-id="element-40" data-mp="3ueih5klswg7n">
            <div className="flex items-center space-x-3 mb-6" data-id="element-41" data-mp="3ucxndx7b91au">
              <img src="https://cdn.magicpatterns.com/uploads/ue8vBFZwEq6iFGtuLhrkM6/Podcastlogo3doves.jpg" alt="3 Doves Podcast" className="h-12 w-12 rounded-full border border-gold-500/30" data-id="element-42" data-mp="37o2ul235f8m" />
              <span className="text-xl font-serif font-bold text-gold-400" data-id="element-43" data-mp="29z6vif77cphh">
                3 Doves
              </span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6" data-id="element-44" data-mp="2ezbag0sgpc5l">
              Honest faith. Real stories. Lives transformed. Join us as we
              explore what it means to walk with God in everyday life.
            </p>
            <div className="flex space-x-4" data-id="element-45" data-mp="3gcaahgjsihhj">
              <a href="#" className="text-white/50 hover:text-gold-400 transition-colors" data-id="element-46" data-mp="3v89dwdvyftgc">
                <Facebook size={20} data-id="element-47" data-mp="3q726ifxq4wa7" />
              </a>
              <a href="#" className="text-white/50 hover:text-gold-400 transition-colors" data-id="element-48" data-mp="82ie9xijwigy">
                <Instagram size={20} data-id="element-49" data-mp="33e71cf6sut9" />
              </a>
              <a href="#" className="text-white/50 hover:text-gold-400 transition-colors" data-id="element-50" data-mp="hsk0ejrcfqt8">
                <Youtube size={20} data-id="element-51" data-mp="cv1uz3cjbtpz" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-52" data-mp="qtro67w8h992">
            <h3 className="text-gold-500 font-serif font-semibold mb-6" data-id="element-53" data-mp="qr5gm89cetqu">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-54" data-mp="tvcz5qtmo3em">
              <li data-id="element-55" data-mp="twfohubaxxsf">
                <Link to="/about" className="text-white/70 hover:text-gold-400 text-sm transition-colors" data-id="element-56" data-mp="twxuvjrohse2">
                  About Jason
                </Link>
              </li>
              <li data-id="element-57" data-mp="18k0sdqg0411e">
                <Link to="/podcasts" className="text-white/70 hover:text-gold-400 text-sm transition-colors" data-id="element-58" data-mp="18kiyrfwdnvn1">
                  All Episodes
                </Link>
              </li>
              <li data-id="element-59" data-mp="1hj4aar3fmaeb">
                <Link to="/guests" className="text-white/70 hover:text-gold-400 text-sm transition-colors" data-id="element-60" data-mp="1hms6jy09hawq">
                  Meet Guests
                </Link>
              </li>
              <li data-id="element-61" data-mp="3obevtoarh49r">
                <Link to="/bookstore" className="text-white/70 hover:text-gold-400 text-sm transition-colors" data-id="element-62" data-mp="3obx27dr50yve">
                  Bookstore
                </Link>
              </li>
            </ul>
          </div>

          {/* Mission */}
          <div data-id="element-63" data-mp="25nvlazp97s93">
            <h3 className="text-gold-500 font-serif font-semibold mb-6" data-id="element-64" data-mp="25nc97zmaby2z">
              Get Involved
            </h3>
            <ul className="space-y-3" data-id="element-65" data-mp="21nbjhitqk0gm">
              <li data-id="element-66" data-mp="1wnpajlkxx6dm">
                <Link to="/outreach" className="text-white/70 hover:text-gold-400 text-sm transition-colors" data-id="element-67" data-mp="1wo8pctfanenf">
                  Operation Olive Branch
                </Link>
              </li>
              <li data-id="element-68" data-mp="2pd5vxza57n0c">
                <Link to="/share" className="text-white/70 hover:text-gold-400 text-sm transition-colors" data-id="element-69" data-mp="2pajrw9mgnpmv">
                  Share
                </Link>
              </li>
              <li data-id="element-70" data-mp="18ynupd9s2syb">
                <Link to="/contact" className="text-white/70 hover:text-gold-400 text-sm transition-colors" data-id="element-71" data-mp="18z5ziyaiafhu">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Listen Now */}
          <div data-id="element-72" data-mp="2wmpp8izxdukp">
            <h3 className="text-gold-500 font-serif font-semibold mb-6" data-id="element-73" data-mp="2wn9ao9osb13h">
              Listen Now
            </h3>
            <div className="space-y-3" data-id="element-74" data-mp="2iwm7o5bzqp1l">
              <a href="https://open.spotify.com/show/5nWVRvG1GtlfUXUfN77LfL?uid=6311ed14474123bc694c&uri=spotify:episode:4Jci4PYyVQ7HoRSNHKKRBt" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 p-3 bg-dark-700 rounded-lg hover:bg-dark-600 transition-colors group border border-dark-600 hover:border-gold-500/30" data-id="element-75" data-mp="2ntw8si8qsp59">
                <div className="w-8 h-8 rounded-full bg-green-500 flex items-center justify-center text-black font-bold text-xs" data-id="element-76" data-mp="36juewsszc869">
                  SP
                </div>
                <span className="text-sm text-white/70 group-hover:text-white" data-id="element-77" data-mp="1v574698ha1or">
                  Spotify
                </span>
              </a>
              <a href="https://podcasts.apple.com/us/podcast/3-doves-podcast/id1871795398" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 p-3 bg-dark-700 rounded-lg hover:bg-dark-600 transition-colors group border border-dark-600 hover:border-gold-500/30" data-id="element-78" data-mp="1nkmtqnxwv9ca">
                <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center text-black font-bold text-xs" data-id="element-79" data-mp="13x6xskxpaago">
                  AP
                </div>
                <span className="text-sm text-white/70 group-hover:text-white" data-id="element-80" data-mp="1dnrt9zi2uyvd">
                  Apple Podcasts
                </span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-dark-700 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-81" data-mp="l7h4k29l5wqv">
          <p className="text-white/50 text-sm text-center md:text-left" data-id="element-82" data-mp="g8noc22wzrn0">
            &copy; {new Date().getFullYear()} 3 Doves Podcast. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-83" data-mp="2g8svzc7ln37s">
            <Link to="/privacy-policy" className="text-white/50 hover:text-gold-400 text-xs transition-colors" data-id="element-84" data-mp="2l8farq32srip">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-white/50 hover:text-gold-400 text-xs transition-colors" data-id="element-85" data-mp="2uy8de1l8pwat">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}